import { useEffect, useState } from "react";
import GetIcon from "../../../../utils/Icon";
import GeneralDetails from "./GeneralDetails";
import TaxDetails from "./TaxDetails";
import RegistrationDetails from "./RegistrationDetails";
import printerimg from "../../../../assets/print.png";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import { usePostUpdateCompanyMutation } from "../../../../store/api/companyapi";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetPurchaseOrderByNameMutation } from "../../../../store/api/purchaseorderapi";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
import Attachment from "../../../../utils/Attachment";
import { usePageState } from "../../../../Hook/usePageState";
import { isStateChanged } from "../../../../utils/stateComparator";
const CompanyForm = () => {
  const nvg = useNavigate();
  const location = useLocation()
  const id =location?.state.companyid 
  // console.log("check localtion",location);
  const [activeTab, setActiveTab] = useState(1);
  const [UpdateCompany] = usePostUpdateCompanyMutation();
  const [isSubmitting, setIsSubmitting] = useState(false); 


  
const pageStateDefault = {
      tab: 1,
       companyName: '',
    abbreviation: '',
    defaultCurrency: '',
    country: '',
    defaultGSTRate: '',
    defaultHolidayList: '',
    defaultLetterHead: '',
    domain: '',
    taxID: '',
    dateOfEstablishment: '',
    parentCompany: '',
    gstinUin: '',
    pan: '',
    gstCategory: '',
    registrationDetails: '',
    isgroup: false,
  
    };
  
    const [pageState, setPageState] = usePageState(`Edit Company - ${id}`, pageStateDefault);
  
  
    const { tab,companyName,abbreviation,defaultCurrency,country,defaultGSTRate,defaultHolidayList,defaultLetterHead,domain,taxID,dateOfEstablishment,parentCompany,gstinUin,pan,gstCategory,registrationDetails,isgroup} = pageState;

  const [getDocByName] = useGetPurchaseOrderByNameMutation();

 useEffect(() => {
  const getData = async () => {
   
    try {
       if (!isStateChanged(pageState, pageStateDefault)) {
      const response = await getDocByName({ doctype: 'Company', name: location.state.companyid });
      const apiData = response.data.message;
    
      const mappedData = {
        companyName: apiData.company_name || '',
        abbreviation: apiData.abbr || '',
        defaultCurrency: apiData.default_currency || '',
        country: apiData.country || '',
        defaultGSTRate: apiData.default_gst_rate || '',
        defaultHolidayList: apiData.default_holiday_list || '',
        defaultLetterHead: apiData.default_letter_head || '',
        domain: apiData.domain || '',
        taxID: apiData.tax_id || '',
        dateOfEstablishment: apiData.date_of_establishment || '',
        parentCompany: apiData.parent_company || '',
        gstinUin: apiData.gstin || '',
        pan: apiData.pan || '',
        gstCategory: apiData.gst_category || '',
        registrationDetails: apiData.registration_details || '',
        isgroup: Boolean(apiData.is_group) || false,
      };

      setPageState(mappedData);
    }
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  };

  if (location.state?.companyid) {
    getData();
  }
}, [location.state?.companyid]);

  const [fieldErrors, setFieldErrors] = useState({
    companyName: false,
  });

  const [apiResponse, setApiResponse] = useState({
    show: false,
    type: 'error',
    message: ''
  });



  const validateForm = () => {
    const errors = {};
    let isValid = true;
    
    setFieldErrors(errors);
    return isValid;
  };

 const handleSubmit = async () => {
  const requiredFields = ['companyName','abbreviation', 'defaultCurrency',]; // Add more fields if needed
  const newErrors = {};

  // Check required fields
  requiredFields.forEach(field => {
    if (!pageState[field]?.trim()) {
      newErrors[field] = true;
    }
  });

  const hasError = Object.keys(newErrors).length > 0;

  setFieldErrors(newErrors);

  if (hasError) {
    setApiResponse({
      show: true,
      type: 'error',
      message: 'Please fill all the required fields.'
    });
    return;
  }

  setIsSubmitting(true);

  try {
    const payload = {
      company_name: location.state.companyid,
      // company_name: pageState.companyName,
      abbr: pageState.abbreviation,
      default_currency: pageState.defaultCurrency || '',
      country: pageState.country || '',
      default_gst_rate: pageState.defaultGSTRate || '',
      domain: pageState.domain,
      default_holiday_list: pageState.defaultHolidayList || '',
      default_letter_head: pageState.defaultLetterHead || '',
      tax_id: pageState.taxID,
      date_of_establishment: pageState.dateOfEstablishment || '',
      parent_company: pageState.parentCompany || '',
      gstin: pageState.gstinUin || '',
      pan: pageState.pan || '',
      gst_category: pageState.gstCategory || '',
      registration_details: pageState.registrationDetails || '',
      is_group: pageState.isgroup || ''
    };

    const response = await UpdateCompany(payload);

   if (response.error) {
  const errorData = response.error.data || {};
  let messages = [];

  if (errorData._error_message) {
    messages.push(errorData._error_message);
  }

  if (errorData._server_messages) {
    try {
      const serverMsgs = JSON.parse(errorData._server_messages);
      serverMsgs.forEach(msgStr => {
        const parsed = JSON.parse(msgStr);
        if (parsed.message) messages.push(parsed.message);
      });
    } catch (e) {
      messages.push(errorData._server_messages); // fallback raw
    }
  }

  if (errorData.exception && !messages.includes(errorData.exception)) {
    messages.push(errorData.exception);
  }

  if (errorData.exc_type && !messages.includes(errorData.exc_type)) {
    messages.push(errorData.exc_type);
  }

  const finalMessage = messages
    .map(msg => msg.replace(/<[^>]+>/g, '').trim())
    .filter(Boolean)
    .join("\n");

  setApiResponse({
    show: true,
    type: 'error',
    message: finalMessage || "Something went wrong"
  });
  return;
}


    setApiResponse({
      show: true,
      type: 'success',
      message: 'Company Updated successfully'
    });

    setTimeout(() => {
      nvg("/master/company/company-list");
    }, 1500);

  } catch (error) {
    setApiResponse({
      show: true,
      type: 'error',
      message: 'Failed to create company'
    });
  } finally {
    setIsSubmitting(false);
  }
};
const handleInputChange1 = (field, value) => {
  setPageState({ ...pageState, [field]: value });
};
  return (
    <>
      {/* Full-page loader overlay */}
      {isSubmitting && (
        <div className="loader-overlay">
          <div className="loader-spinner">
            <div className="spinner-border" style={{color:'#270b79'}} role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      )}

      <FormLayoutTwo
        title="Edit Company"
        breadcrumbs={[
          { label: "Company" },
          { label: "Company List", url: "/master/company/company-list" }
        ]}
        status={'hide'}
        actionButtons={
          <>
          <Button 
                        className="custom-btn-00989"
                        onClick={handleSubmit}
                        iconName="LuFilePlus2"
                        style={{gap:'2px',height:'28px'}}
                        iconSize={12}
                        disabled={isSubmitting} // Disable button during submission
                      >
                        {isSubmitting ? 'Saving...' : 'Save'}
                      </Button>
            <Button 
              to="/" 
              className="px-2"
              imgSrc={printerimg}
              imgStyle={{ width: '21px' }}
            />
          </>
        }
      >
        <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
          <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
            <div className="d-flex justify-content-between align-items-end">
              <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                  <a 
                    className={activeTab === 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} 
                    onClick={() => setPageState({ ...pageState, tab: 1 })}
                  >
                    General Details{activeTab === 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                  </a>
                </li>
              </ul>

                 <Attachment doctype="Company"  docname={id}  /> 

            </div>
          </div>


  <div className=" " style={{ background: '' }}>
                    <div className="row">
                      <div className="col-12">
                        <div >
                        <GeneralDetails
  pageState={pageState}
  handleChange={(f, v) => setPageState({ ...pageState, [f]: v })}
  onInputChange={(f, v) => setPageState({ ...pageState, [f]: v })}
  errors={fieldErrors}
                   id={id}
                />
                {/* <TaxDetails 
                  pageState={pageState} 
                  handleChange={handleInputChange} 
                  errors={fieldErrors} 
                  id={id}
                /> */}
                {/* <RegistrationDetails
                  pageState={pageState} 
                  handleChange={handleInputChange} 
                  errors={fieldErrors} 
                /> */}
                        </div>
                      </div>
                    </div>
                  </div> 

         
        </div>

        <ApiResponseBox
          poptype={apiResponse.type}
          show={apiResponse.show}
          errorMessage={apiResponse.message}
          onClose={() => setApiResponse(prev => ({...prev, show: false}))}
        />
      </FormLayoutTwo>
   
    </>
  );
};

export default CompanyForm;